var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.0007 25.6668C7.55733 25.6668 2.33398 20.4434 2.33398 14.0002C2.33398 7.55684 7.55733 2.3335 14.0007 2.3335C20.4439 2.3335 25.6673 7.55684 25.6673 14.0002C25.6673 20.4434 20.4439 25.6668 14.0007 25.6668ZM12.834 12.8335H8.16732V15.1668H12.834V19.8335H15.1673V15.1668H19.834V12.8335H15.1673V8.16683H12.834V12.8335Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIconWhite);
export default __webpack_public_path__ + "static/media/Add_icon_white.d1dc6ab3086906c57b303b0aef21a70b.svg";
export { ForwardRef as ReactComponent };